import { signOut } from "@aws-amplify/auth";
import { LogOut } from "lucide-react";
import { useState } from "react";

import { cn } from "../lib/cn";

/**
 * Sign out of Cognito, then reload so the auth gate shows the login screen. A failed
 * sign-out is said out loud rather than swallowed: doing nothing visible would let the
 * reader believe they had signed out while the session was still live.
 */
export default function SignOutButton({ className }: { className?: string }) {
  const [failed, setFailed] = useState(false);

  return (
    <div className={cn("flex shrink-0 items-center gap-3", className)}>
      {failed ? (
        <span role="alert" className="text-cell text-[color:var(--acuity-4-fg)]">
          Sign-out failed — you are still signed in
        </span>
      ) : null}
      <button
        type="button"
        onClick={() => {
          setFailed(false);
          signOut().then(
            () => window.location.reload(),
            () => setFailed(true),
          );
        }}
        className="flex shrink-0 items-center gap-2 text-tab text-ink hover:text-ink-3"
      >
        Sign out
        <LogOut size={16} strokeWidth={1.4} aria-hidden />
      </button>
    </div>
  );
}
